module.exports = "<div class=\"user-avatar\" [style.width]=\"size + 'px'\" \n                         [style.height]=\"size + 'px'\" \n                         [style.backgroundImage]=\"logo\">\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/user-avatar/user-avatar.template.html
// module id = ../../../../../src/app/shared/components/user-avatar/user-avatar.template.html
// module chunks = 12